<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex justify-center">
        <img class="logo mb-2 mb-md-4" src="@/assets/logo.svg" />
      </v-col>

      <v-col cols="12" sm="8" md="4" offset-sm="2" offset-md="4" class="d-flex justify-center">
        <v-btn-toggle v-model="type" color="primary" class="mb-2 mb-md-6" mandatory style="width:100%">
          <v-btn class="mr-2" width="50%"> {{ $t('program') }} </v-btn>

          <v-btn width="50%"> {{ $t('liveBroadcast') }} </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <Program v-if="type == 0" class="d-flex justify-center"/>

    <Live v-if="type == 1" class="d-flex justify-center"/>

    <v-row>
      <v-col cols="12" class="d-flex justify-center">
        <v-btn
          @click="onCustomInstall"
          v-if="showInstallBtn"
          depressed
          class="mt-4 mt-md-8 primary"
        >
          {{ $t('appInstallation') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Program from "@/views/home/Program";
import Live from "@/views/home/Live";

export default {
  components: {
    Program,
    Live,
  },
  data() {
    return {
      type: 0,
      installEvent: null,
      showInstallBtn: false,
      isDevelopment: process.env.NODE_ENV == "development",
      isMobile: false,
    };
  },
  async created() {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      this.installEvent = e;
      this.showInstallBtn = true;
    });
  },
  computed: {
    isPWA() {
      const isStandalone = window.matchMedia(
        "(display-mode: standalone)"
      ).matches;

      if (navigator.standalone || isStandalone) {
        return true;
      }

      return false;
    },
  },
  methods: {
    async onCustomInstall() {
      this.installEvent.prompt();

      const choiceResult = await this.installEvent.userChoice;

      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the install prompt");
      } else {
        console.log("User dismissed the install prompt");
      }
    },
    onOpenApp() {
      window.open("https://testing-5b63a.web.app/");
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  height: 30px;
}
</style>
